import API from "../index";
import { compose, prop, path } from "ramda";
import { Profile, Account, UserPremiumStatus } from "./entities";

const getProfile = () =>
  API.Account.getProfile().then(prop("data")).then(Profile);
const getAccount = () => API.Account.getAccount().then(prop("data")).then(Account);

const getUserPremiumStatus = (externalAccountId) =>
  API.Subscription.getBenefits({ externalAccountId }).then(
    compose(UserPremiumStatus, path(["data", "items"]))
  );

const createEmailVerificationLink = () =>
  API.Account.createEmailVerificationLink().then(() => undefined);

export { getProfile, getAccount, getUserPremiumStatus, createEmailVerificationLink };
